import React from 'react'
import styles from './styles.module.scss'

const Tile = (props) => {
  const { color, size, className, badge } = props
  let extendedClass = className ? className : ''
  let updatedProps = { ...props, className: `${styles.tile} ${styles[color]} ${styles[size]} ${extendedClass}` }
  return (
    <a href={props.defaultOption} {...updatedProps}>
      {badge && <span className={`${styles.badge} ${styles.badgeGreenReverse}`}>{badge}</span>}
      {props.children}
    </a>
  )
}

export default Tile
